// extracted by mini-css-extract-plugin
export default {"actions":"product-table-row_actions__KIApa","last-row":"product-table-row_last-row__NNLNq","wrapProductTableRow":"product-table-row_wrapProductTableRow__m-XMb"};